export const SIDE_MENU_TRACKING = {
  op: 'ui',
  name: 'SideMenu',
  portal: 'track',
  menuItemGroups: [
    {
      label: 'track:labels.menu.reporting',
      menuItems: [
        {
          type: 'general',
          label: 'track:page.overview.title',
          icon: 'OverviewIcon',
          to: '/',
          visibility: [
            { type: 'account-field', path: 'config.portals.tracking.dashboard.sisenseId' },
            { type: 'feature-flag', flag: 'track-overview-feature' },
          ],
          testId: 'overview-menu-item',
        },
        {
          type: 'dashboard',
          subtype: 'reports',
          icon: 'ReportsIcon',
          label: 'track:page.reports.title',
          testId: 'reports-button',
          visibility: [
            { type: 'feature-flag', flag: 'track-reports-feature' },
          ],
        },
        {
          type: 'dashboard',
          subtype: 'dashboards',
          icon: 'DashboardAlt',
          label: 'track:page.dashboards.title',
          testId: 'dashboards-button',
          visibility: [
            { type: 'feature-flag', flag: 'track-dashboards-feature' },
          ],
        },
        {
          type: 'dashboard',
          subtype: 'analytics',
          icon: 'AnalyticsIcon',
          label: 'track:page.analytics.title',
          testId: 'analytics-button',
          visibility: [
            { type: 'feature-flag', flag: 'track-analytics-feature' },
          ],
        },
      ],
    },
    {
      label: 'track:labels.menu.track',
      menuItems: [
        {
          type: 'general',
          label: 'track:page.thing-map.title',
          icon: 'MapIcon',
          to: ['/map/', { type: 'custom-route', name: 'things' }],
          activePaths: [
            ['/map/', { type: 'custom-route', name: 'things' }, '/:id'],
          ],
          testId: 'map-button',
        },
        {
          type: 'general',
          label: 'terms:thing_other',
          icon: 'ThingIcon',
          to: ['/', { type: 'custom-route', name: 'things' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'thing' }, '/:id'],
          ],
          testId: 'things-button',
        },
        {
          type: 'general',
          label: 'terms:person_other',
          icon: 'PersonIcon',
          to: ['/', { type: 'custom-route', name: 'people' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'person' }, '/:id'],
          ],
          testId: 'persons-button',
        },
        {
          type: 'alerts',
          label: 'common:terms.alert_other',
          icon: 'AlertIcon',
          to: ['/', { type: 'custom-route', name: 'alerts' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'alert' }, '/:id'],
          ],
          visibility: [
            { type: 'role-function', roleFunctions: ['alert-viewer'] },
          ],
          testId: 'alerts-button',
        },
      ],
    },
  ],
  footerMenuItems: [
    {
      type: 'templated-page',
      templateId: 'marketplace',
      label: 'admin:page.marketplace.title',
      icon: 'MarketIcon',
      visibility: [
        { type: 'feature-flag', flag: 'admin-marketplace-feature' },
      ],
      testId: 'portal-navigation-marketplace',
    },
    {
      type: 'help',
      icon: 'Help',
      label: 'common:component.navigation.footer.labels.support',
      testId: 'help-button',
      visibility: [
        { type: 'feature-flag', flag: 'portals-intercom-guide-feature' },
      ],
    },
    {
      type: 'feedback',
      icon: 'MessageSquare',
      label: 'common:common.labels.feedback',
      testId: 'feedback-button',
      hotjarAction: 'show_feedback_form',
      visibility: [
        { type: 'feature-flag', flag: 'portals-feedback-sidebar-button-feature' },
      ],
    },
    {
      type: 'portal-version',
      icon: 'Info',
      testId: 'portal-version',
      visibility: [
        { type: 'feature-flag', flag: 'portals-display-portal-version-in-sidebar' },
      ],
    },
  ],
  isOpen: {
    op: 'context',
    path: 'isOpen',
  },
};

export const SIDE_MENU_MANAGE = {
  op: 'ui',
  name: 'SideMenu',
  portal: 'manage',
  menuItemGroups: [
    {
      label: 'manage:labels.menu.management',
      menuItems: [
        {
          type: 'general',
          label: 'terms:thing_other',
          icon: 'ThingIcon',
          to: ['/', { type: 'custom-route', name: 'things' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'thing' }, '/:id'],
          ],
          testId: 'things-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.device_other',
          icon: 'DeviceIcon',
          to: ['/', { type: 'custom-route', name: 'devices' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'device' }, '/:gatewayId/:id'],
            ['/', { type: 'custom-route', name: 'device' }, '/create'],
          ],
          testId: 'devices-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.installation_other',
          icon: 'InstallIcon',
          to: ['/', { type: 'custom-route', name: 'installations' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'installation' }, '/:id'],
          ],
          visibility: [
            { type: 'role-function', roleFunctions: ['installer', 'tech-support'] },
          ],
          testId: 'installations-menu-item',
        },
        {
          type: 'general',
          label: 'manage:page.stickers.title',
          icon: 'StickerIcon',
          to: ['/', { type: 'custom-route', name: 'stickers' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'stickers' }, '/qr-code'],
          ],
          visibility: [
            { type: 'role-function', roleFunctions: ['installer'] },
          ],
          testId: 'stickers-menu-item',
        },
      ],
    },
    {
      label: 'manage:labels.menu.system',
      menuItems: [
        {
          type: 'general',
          label: 'manage:page.device-types-list.title',
          icon: 'DeviceIcon',
          to: ['/', { type: 'custom-route', name: 'deviceTypes' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'deviceType' }, '/:id'],
          ],
          visibility: [
            { type: 'feature-flag', flag: 'manage-device-types-feature' },
          ],
          testId: 'device-types-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.thing-type_other',
          icon: 'ThingIcon',
          to: ['/', { type: 'custom-route', name: 'thing' }, '-types'],
          activePaths: [
            ['/', { type: 'custom-route', name: 'thing' }, '-type/:id'],
          ],
          visibility: [
            { type: 'feature-flag', flag: 'manage-thing-type-feature' },
            { type: 'role-function', roleFunctions: ['installer', 'tech-support'] },
          ],
          testId: 'thing-types-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.person-type_other',
          icon: 'PersonIcon',
          to: ['/', { type: 'custom-route', name: 'person' }, '-types'],
          activePaths: [
            ['/', { type: 'custom-route', name: 'person' }, '-type/:id'],
          ],
          visibility: [
            { type: 'feature-flag', flag: 'manage-person-type-feature' },
          ],
          testId: 'person-types-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.geofence-type_other',
          icon: 'GeofenceIcon',
          to: ['/', { type: 'custom-route', name: 'geofence' }, '-types'],
          activePaths: [
            ['/', { type: 'custom-route', name: 'geofence' }, '/type/:id'],
            ['/', { type: 'custom-route', name: 'geofence' }, '/new-', { type: 'custom-route', name: 'geofence' }, '-type'],
          ],
          visibility: [
            { type: 'feature-flag', flag: 'manage-geofence-types-feature' },
            { type: 'role-function', roleFunctions: ['geofence-administrator'] },
          ],
          testId: 'geofence-types-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.point-of-interest-type_other',
          icon: 'PointOfInterestIcon',
          to: '/point-of-interest/types',
          activePaths: [
            ['/', { type: 'custom-route', name: 'pointOfInterest' }, '/type/:id'],
          ],
          visibility: [
            { type: 'feature-flag', flag: 'manage-point-of-interest-type-set-feature' },
            { type: 'role-function', roleFunctions: ['system-administrator'] },
          ],
          testId: 'point-of-interest-types-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.point-of-interest-set_other',
          icon: 'PointOfInterestIcon',
          to: '/point-of-interest/sets',
          activePaths: [
            ['/', { type: 'custom-route', name: 'pointOfInterest' }, '/set/:id'],
            ['/', { type: 'custom-route', name: 'pointOfInterest' }, '-set/create'],
          ],
          visibility: [
            { type: 'feature-flag', flag: 'manage-point-of-interest-type-set-feature' },
            { type: 'role-function', roleFunctions: ['system-administrator'] },
          ],
          testId: 'point-of-interest-sets-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.installation-template_other',
          icon: 'InstallIcon',
          to: ['/', { type: 'custom-route', name: 'installationTemplates' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'installationTemplate' }, '/:id'],
          ],
          visibility: [
            { type: 'feature-flag', flag: 'manage-installation-templates-feature' },
            { type: 'role-function', roleFunctions: ['installer', 'tech-support'] },
          ],
          testId: 'installation-templates-types-menu-item',
        },
      ],
    },
    {
      label: 'manage:labels.menu.account',
      menuItems: [
        {
          type: 'general',
          label: 'common:terms.account_other',
          icon: 'AccountIcon',
          to: ['/', { type: 'custom-route', name: 'accounts' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'account' }, '/:id'],
            ['/', { type: 'custom-route', name: 'account' }, '/create'],
          ],
          visibility: [
            { type: 'feature-flag', flag: 'manage-accounts-feature' },
            { type: 'role-function', roleFunctions: ['system-administrator', 'account-administrator'] },
          ],
          testId: 'account-menu-item',
        },
      ],
    },
  ],
  footerMenuItems: [
    {
      type: 'feedback',
      icon: 'MessageSquare',
      label: 'common:common.labels.feedback',
      testId: 'feedback-button',
      hotjarAction: 'show_feedback_form',
      visibility: [
        { type: 'feature-flag', flag: 'portals-feedback-sidebar-button-feature' },
      ],
    },
    {
      type: 'general',
      icon: 'ExternalLink',
      to: [{ type: 'domain-config', path: 'portals.manage.supportUrl.url' }],
      label: 'common:common.labels.support',
      testId: 'portal-navigation-support',
      openInNewTab: true,
      visibility: [
        { type: 'feature-flag', flag: 'portals-support-link-feature' },
        { type: 'domain-config', path: 'portals.manage.supportUrl.url' },
      ],
    },
    {
      type: 'portal-version',
      icon: 'Info',
      testId: 'portal-version',
      visibility: [
        { type: 'feature-flag', flag: 'portals-display-portal-version-in-sidebar' },
      ],
    },
  ],
  isOpen: {
    op: 'context',
    path: 'isOpen',
  },
};

export const SIDE_MENU_ADMIN = {
  op: 'ui',
  name: 'SideMenu',
  portal: 'admin',
  menuItemGroups: [
    {
      label: 'admin:labels.menu.manage',
      menuItems: [
        {
          type: 'general',
          label: 'terms:thing_other',
          icon: 'ThingIcon',
          to: ['/', { type: 'custom-route', name: 'things' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'thing' }, '/:id'],
            ['/new-', { type: 'custom-route', name: 'thing' }],
          ],
          testId: 'thing-menu-item',
        },
        {
          type: 'general',
          label: 'common:page.contract-management.title',
          icon: 'ContractIcon',
          to: '/contract-management',
          visibility: [
            { type: 'feature-flag', flag: 'admin-contract-management-feature' },
            { type: 'domain-config', path: 'paymentGateway.enabled' },
          ],
          testId: 'contract-management-menu-item',
        },
        {
          type: 'general',
          label: 'terms:person_other',
          icon: 'PersonIcon',
          to: ['/', { type: 'custom-route', name: 'people' }],
          activePaths: [
            ['/', { type: 'custom-route', name: 'person' }, '/:id'],
            ['/new-', { type: 'custom-route', name: 'person' }],
          ],
          testId: 'person-menu-item',
        },
        {
          type: 'general',
          label: 'admin:page.pending-transfers.title',
          icon: 'TransfersIcon',
          to: ['/', { type: 'custom-route', name: 'things' }, '/', { type: 'custom-route', name: 'transfers' }],
          visibility: [
            { type: 'feature-flag', flag: 'admin-life-cycle-feature' },
            { type: 'role-function', roleFunctions: ['thing-administrator', 'life-cycle-viewer'] },
          ],
          testId: 'transfers-menu-item',
        },
        {
          type: 'general',
          label: 'admin:page.lease-management.title',
          icon: 'LeaseManagementIcon',
          to: ['/', { type: 'custom-route', name: 'things' }, '/lease-management'],
          visibility: [
            { type: 'feature-flag', flag: 'admin-lease-management-feature' },
            { type: 'role-function', roleFunctions: ['thing-administrator'] },
            { type: 'account-field', path: 'properties.canLease.value' },
          ],
          testId: 'lease-management-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.account_other',
          icon: 'AccountIcon',
          to: ['/', { type: 'custom-route', name: 'accounts' }],
          visibility: [
            { type: 'feature-flag', flag: 'manage-accounts-feature' },
            { type: 'role-function', roleFunctions: ['system-administrator', 'account-administrator'] },
          ],
          activePaths: [
            ['/', { type: 'custom-route', name: 'account' }, '/:id'],
            ['/', { type: 'custom-route', name: 'account' }, '/create'],
          ],
          testId: 'accounts-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.group_other',
          icon: 'GroupIcon',
          to: ['/', { type: 'custom-route', name: 'groups' }],
          visibility: [
            { type: 'role-function', roleFunctions: ['group-administrator'] },
          ],
          activePaths: [
            ['/', { type: 'custom-route', name: 'group' }, '/:id'],
            ['/new-', { type: 'custom-route', name: 'group' }],
          ],
          testId: 'groups-menu-item',
        },
      ],
    },
    {
      label: 'admin:labels.menu.alerts',
      menuItems: [
        {
          type: 'general',
          label: 'admin:page.alert-condition.title',
          icon: 'AlertConditionsIcon',
          to: ['/', { type: 'custom-route', name: 'alertConditions' }],
          visibility: [
            { type: 'feature-flag', flag: 'admin-alert-conditions-feature' },
            { type: 'role-function', roleFunctions: ['alert-administrator'] },
          ],
          activePaths: [
            ['/', { type: 'custom-route', name: 'alertCondition' }, '/:id'],
            ['/', { type: 'custom-route', name: 'alertCondition' }, '/create'],
          ],
          testId: 'alert-condition-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.subscription_other',
          icon: 'AlertIcon',
          to: ['/', { type: 'custom-route', name: 'subscriptions' }],
          visibility: [
            { type: 'role-function', roleFunctions: ['subscription-administrator'] },
          ],
          activePaths: [
            ['/recipient/', { type: 'custom-route', name: 'subscription' }, '/:id'],
            ['/', { type: 'custom-route', name: 'subscription' }, '/create'],
          ],
          testId: 'subscriptions-menu-item',
        },
      ],
    },
    {
      label: 'admin:labels.menu.users',
      menuItems: [
        {
          type: 'general',
          label: 'common:terms.user_other',
          icon: 'User',
          to: '/users',
          visibility: [
            { type: 'role-function', roleFunctions: ['iam-administrator'] },
          ],
          activePaths: [
            '/user/:id',
            '/user/create',
          ],
          ignoredPaths: [
            ['/user/', { type: 'custom-route', name: 'groups' }],
            '/user/roles',
          ],
          testId: 'users-menu-item',
        },
        {
          type: 'general',
          label: 'admin:page.user-group-list.title',
          icon: 'Users',
          to: ['/user/', { type: 'custom-route', name: 'groups' }],
          visibility: [
            { type: 'role-function', roleFunctions: ['iam-administrator'] },
          ],
          activePaths: [
            ['/user-', { type: 'custom-route', name: 'group' }, '/:id'],
            ['/new-user-', { type: 'custom-route', name: 'group' }],
          ],
          testId: 'user-groups-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.role_other',
          icon: 'UserRolesIcon',
          to: '/user/roles',
          visibility: [
            { type: 'role-function', roleFunctions: ['iam-administrator', 'system-administrator'] },
          ],
          activePaths: [
            '/role/:id',
            '/role/create',
          ],
          testId: 'user-roles-menu-item',
        },
        {
          type: 'general',
          label: 'admin:page.oidc-group-mapping.title',
          icon: 'Component',
          to: ['/', { type: 'custom-route', name: 'oidcGroupMapping' }],
          visibility: [
            { type: 'feature-flag', flag: 'admin-oidc-group-mapping-feature' },
            { type: 'role-function', roleFunctions: ['iam-administrator'] },
          ],
          activePaths: [
            ['/', { type: 'custom-route', name: 'oidcGroupMapping' }, '/:id'],
            '/new-oidc-group-mapping',
          ],
          testId: 'oidc-group-mapping-menu-item',
        },
      ],
    },
    {
      label: 'admin:label.menu.map',
      menuItems: [
        {
          type: 'general',
          label: 'common:terms.geofence_other',
          icon: 'GeofenceIcon',
          to: ['/', { type: 'custom-route', name: 'geofences' }],
          visibility: [
            { type: 'feature-flag', flag: 'portals-geofence-feature' },
            { type: 'role-function', roleFunctions: ['geofence-administrator'] },
          ],
          activePaths: [
            ['/', { type: 'custom-route', name: 'geofence' }, '/:id'],
            ['/', { type: 'custom-route', name: 'geofence' }, '/create'],
          ],
          ignoredPaths: [
            ['/', { type: 'custom-route', name: 'geofence' }, '/', { type: 'custom-route', name: 'groups' }],
          ],
          testId: 'geofence-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.geofence-type_other',
          icon: 'GeofenceIcon',
          to: ['/', { type: 'custom-route', name: 'geofence' }, '-types'],
          visibility: [
            { type: 'feature-flag', flag: 'portals-geofence-feature' },
            { type: 'role-function', roleFunctions: ['geofence-administrator', 'system-administrator'] },
          ],
          activePaths: [
            ['/', { type: 'custom-route', name: 'geofence' }, '/type/:id'],
            ['/', { type: 'custom-route', name: 'geofence' }, '/new-', { type: 'custom-route', name: 'geofence' }, '-type'],
          ],
          testId: 'geofence-types-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.geofence-group_other',
          icon: 'GeofenceIcon',
          to: ['/', { type: 'custom-route', name: 'geofence' }, '/', { type: 'custom-route', name: 'groups' }],
          visibility: [
            { type: 'feature-flag', flag: 'portals-geofence-feature' },
            { type: 'role-function', roleFunctions: ['geofence-administrator'] },
          ],
          activePaths: [
            ['/', { type: 'custom-route', name: 'geofence' }, '/', { type: 'custom-route', name: 'group' }, '/:id'],
            ['/', { type: 'custom-route', name: 'geofence' }, '/new-', { type: 'custom-route', name: 'geofence' }, '-', { type: 'custom-route', name: 'group' }],
          ],
          testId: 'geofence-group-menu-item',
        },
        {
          type: 'general',
          label: 'common:terms.point-of-interest-set_other',
          icon: 'PointOfInterestIcon',
          to: '/point-of-interest/sets',
          visibility: [
            { type: 'feature-flag', flag: 'admin-point-of-interest-set-feature' },
            { type: 'role-function', roleFunctions: ['point-of-interest-administrator'] },
          ],
          activePaths: [
            '/point-of-interest/set/:id',
            '/point-of-interest-set/create',
          ],
          testId: 'point-of-interest-set-menu-item',
        },
      ],
    },
    {
      label: 'admin:label.menu.connectors',
      menuItems: [
        {
          type: 'general',
          label: 'admin:page.authorized-applications.title',
          icon: 'AuthorizedAppIcon',
          to: ['/', { type: 'custom-route', name: 'authorizedApplications' }],
          visibility: [
            { type: 'feature-flag', flag: 'admin-authorized-applications-feature' },
            { type: 'role-function', roleFunctions: ['application-administrator'] },
          ],
          activePaths: [
            ['/', { type: 'custom-route', name: 'authorizedApplication' }, '/:id'],
            ['/', { type: 'custom-route', name: 'authorizedApplication' }, '/create'],
          ],
          testId: 'authorized-applications-menu-item',
        },
        {
          type: 'general',
          label: 'admin:page.micro-portal-playground.title',
          icon: 'ModuleIcon',
          to: '/micro-portal-playground',
          visibility: [
            { type: 'feature-flag', flag: 'admin-micro-portal-playground-environment-feature' },
            { type: 'role-function', roleFunctions: ['application-administrator'] },
          ],
          testId: 'micro-portal-playground-menu-item',
        },
      ],
    },
  ],
  footerMenuItems: [
    {
      type: 'templated-page',
      templateId: 'marketplace',
      label: 'admin:page.marketplace.title',
      icon: 'MarketIcon',
      visibility: [
        { type: 'feature-flag', flag: 'admin-marketplace-feature' },
      ],
      testId: 'portal-navigation-marketplace',
    },
    {
      type: 'help',
      icon: 'Help',
      label: 'common:component.navigation.footer.labels.support',
      testId: 'help-button',
      visibility: [
        { type: 'feature-flag', flag: 'portals-intercom-guide-feature' },
      ],
    },
    {
      type: 'feedback',
      icon: 'MessageSquare',
      label: 'common:common.labels.feedback',
      testId: 'feedback-button',
      hotjarAction: 'show_feedback_form',
      visibility: [
        { type: 'feature-flag', flag: 'portals-feedback-sidebar-button-feature' },
      ],
    },
    {
      type: 'general',
      icon: 'ExternalLink',
      to: [{ type: 'domain-config', path: 'portals.admin.supportUrl.url' }],
      label: 'common:common.labels.support',
      testId: 'portal-navigation-support',
      openInNewTab: true,
      visibility: [
        { type: 'feature-flag', flag: 'portals-support-link-feature' },
        { type: 'domain-config', path: 'portals.admin.supportUrl.url' },
      ],
    },
    {
      type: 'portal-version',
      icon: 'Info',
      testId: 'portal-version',
      visibility: [
        { type: 'feature-flag', flag: 'portals-display-portal-version-in-sidebar' },
      ],
    },
  ],
  isOpen: {
    op: 'context',
    path: 'isOpen',
  },
};
